<template>
    <div class="firmaconLogin">
                    <h3>La operación requiere de OTP</h3>
                    <br/>
                    <label class="labelClaveFirma">Introduzca el código que le hemos enviado</label>
                    <input class="inputLoginComponent" type="text" maxlength="8" name="pin" placeholder="Código de verificación" v-model="pin" required/>
                    <br>
                    <input class="btnPrimary" type="button" value="Aceptar" :disabled="isDisabled" @click="aceptarOTP">
                    <!-- Boton cancelar -->
                    <input type="button" class="btnSecondary" @click="cancelar()" value="Cancelar">
    </div>
</template>

<script>
export default {
    name : 'OTPComponent',
    data(){
      return{
        datosSalida:null,
        mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
        confirmacion:null,
        pin: null
      }
    },
    props: {
      params: new Object(),
      datosOTP: new Object(),
      llamada: new Object(),
      queries: new Object()
    },
    computed : {
      isDisabled: function() {
          return !this.pin;
      }
    },
    methods: {
      aceptarOTP (){
          const ventana = this;
          const baseURI = this.llamada.urlEndpoint;
          var options = {
            headers: {
                'Authorization':this.llamada.login ? 'Basic UENfRXVyb2NhamE6c2VjcmV0X3Bj' : this.$http.defaults.headers.common['Authorization'],
                'X-SIGNATURE-TRANSACTION': this.datosOTP.transactionCode,
                'X-SIGNATURE-KEY': this.pin,
                'X-SIGNATURE-TYPE':this.datosOTP.type,
                'X-CHANNEL-KEY':this.llamada.canal!=null ? this.llamada.canal : 'B'
            },
            params:this.queries
          };
          let loader = this.$loading.show();
          var confirmacion = null;
          if(this.llamada.metodo=='POST'){
            this.$http.post(baseURI, this.params, options)
            .then((result) => {
              this.datosSalida=result;
              confirmacion = "OK";
              ventana.$emit('aceptar', confirmacion, result);
            })
            .catch(function (error) {
              if(error.response.status != 200) {
                var codError;
                //var descError;
                if(error.response.data.result!=null){
                  codError = error.response.data.result.errors[0].errorCode;
                  //descError = error.response.data.result.errors[0].errorDescription;
                }else{
                  codError = error.response.data.error;
                  //descError = error.response.data.error_description;
                }
                var mensajeError = codError + " - " + ventana.mensajeError;
                confirmacion = "KO";
                ventana.$emit('aceptar', confirmacion, mensajeError, codError);
              }
            })
            .then(function () {
              loader.hide();
            });
          }else if(this.llamada.metodo=='PUT'){
            this.$http.put(baseURI, this.params, options)
            .then((result) => {
              this.datosSalida=result;
              confirmacion = "OK";
              ventana.$emit('aceptar', confirmacion);
            })
            .catch(function (error) {
              if(error.response.status != 200) {
                var codError = error.response.data.result.errors[0].errorCode;
                //var descError = error.response.data.result.errors[0].errorDescription;
                var mensajeError = codError + " - " + ventana.mensajeError;
                confirmacion = "KO";
                ventana.$emit('aceptar', confirmacion, mensajeError, codError);
              }
            })
            .then(function () {
              loader.hide();
            });
          }else if(this.llamada.metodo=='GET'){
            this.$http.get(baseURI, options)
            .then((result) => {
              confirmacion = "OK";
              ventana.$emit('rellenarDatos', confirmacion, result);
            })
            .catch(function (error) {
              if(error.response.status != 200) {
                var codError = error.response.data.result.errors[0].errorCode;
                //var descError = error.response.data.result.errors[0].errorDescription;
                var mensajeError = codError + " - " + ventana.mensajeError;
                confirmacion = "KO";
                ventana.$emit('aceptar', confirmacion, mensajeError, codError);
              }
            })
            .then(function () {
              loader.hide();
            });
          }
      },
      
      cancelar(){
        let loader = this.$loading.show();
        this.pin=null;
        setTimeout(() => {
          loader.hide();    
        },700);
        this.$emit('cancelar');
      }
    }
}
</script>